import React from 'react'  
import PropTypes from 'prop-types'
import axios from 'axios';
import CardSlider from './CardSlider'
import { CARD_HEADLINE_STYLES } from './Card';

import _ from 'lodash'

class ConcertNewsSlider extends React.Component {
  constructor () {
    super();
    this.state = {
      concerts: []
    };
  }

  componentWillMount () {
    axios.get( '/api/concerts/news' )
    .then(response => {

      let transformed = []
      response.data.map((item, index) =>
        transformed.push(
          {
            key: item.id,
            image: item.img_sm,
            imageLink: `/artists/${item.a_slug}`,
            category: item.date_de,
            headline: `${item.a_name} (${item.a_cc})`,
            headlineLink: `/artists/${item.a_slug}`,
            subheadline: `${item.l_name}, ${item.c_name}`,
            subheadlineLink: `/${item.l_slug}`,
            buttonLink: item.ticket_link,
            buttonLabel: item.boxoffice? 'Infos' : 'Tickets',
            buttonBackgroundImage: item.tp_img,
          }
        )
      )

      this.setState({ concerts: transformed});
    })
    .catch(error => {
      console.error(error);
    });
  }
  render () {
    return (
        this.state.concerts.length > 0 && 
          <CardSlider showButtons={true} items={this.state.concerts} cardHeadlineStyle={CARD_HEADLINE_STYLES.REGULAR} />
    );
  }
}

export default ConcertNewsSlider;